// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_iso4217 from "../../commonapis/gen/buhta_common_v1_iso4217.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  139,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "SalaryType"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "SalaryPeriod"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "SalaryMethod"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "SalaryRate"
                ]
              ]
            },
            "V1"
          ]]
      },
      "Payroll"
    ]]
});

const Payroll = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  240,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "SalaryType"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "SalaryPeriod"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "SalaryMethod"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "SalaryRate"
          ]
        ]
      },
      "V1"
    ]]
});

const V1 = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  339,
  10
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "SalaryType"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "SalaryPeriod"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "SalaryMethod"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "SalaryRate"
    ]
  ]
});

const SalaryType = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  362,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
});

const SalaryPeriod = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  425,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
});

const SalaryMethod = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  492,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
});

const SalaryRate = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_v1_salary.ml",
  556,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.payroll.v1.SalaryType";
}

function to_int(param) {
  switch (param) {
    case /* SALARY_TYPE_UNSPECIFIED */ 0 :
      return 0;
    case /* SALARY_TYPE_GIG */ 1 :
      return 1;
    case /* SALARY_TYPE_METERED */ 2 :
      return 2;
    case /* SALARY_TYPE_RATE */ 3 :
      return 3;
    case /* SALARY_TYPE_PERIOD */ 4 :
      return 4;
  }
}

function from_int_exn(n) {
  if (n > 4 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
      NAME: "Unknown_enum_value",
      VAL: n
    });
  } else {
    return n;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return from_int_exn(e);
  });
}

function to_string(param) {
  switch (param) {
    case /* SALARY_TYPE_UNSPECIFIED */ 0 :
      return "SALARY_TYPE_UNSPECIFIED";
    case /* SALARY_TYPE_GIG */ 1 :
      return "SALARY_TYPE_GIG";
    case /* SALARY_TYPE_METERED */ 2 :
      return "SALARY_TYPE_METERED";
    case /* SALARY_TYPE_RATE */ 3 :
      return "SALARY_TYPE_RATE";
    case /* SALARY_TYPE_PERIOD */ 4 :
      return "SALARY_TYPE_PERIOD";
  }
}

function from_string_exn(s) {
  switch (s) {
    case "SALARY_TYPE_GIG" :
      return /* SALARY_TYPE_GIG */ 1;
    case "SALARY_TYPE_METERED" :
      return /* SALARY_TYPE_METERED */ 2;
    case "SALARY_TYPE_PERIOD" :
      return /* SALARY_TYPE_PERIOD */ 4;
    case "SALARY_TYPE_RATE" :
      return /* SALARY_TYPE_RATE */ 3;
    case "SALARY_TYPE_UNSPECIFIED" :
      return /* SALARY_TYPE_UNSPECIFIED */ 0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_name",
        VAL: s
      });
  }
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
}, SalaryType, {
  name: name,
  to_int: to_int,
  from_int: from_int,
  from_int_exn: from_int_exn,
  to_string: to_string,
  from_string_exn: from_string_exn
});

function name$1(param) {
  return ".buhta.payroll.v1.SalaryPeriod";
}

function to_int$1(param) {
  switch (param) {
    case /* SALARY_PERIOD_UNSPECIFIED */ 0 :
      return 0;
    case /* SALARY_PERIOD_HOURLY */ 1 :
      return 1;
    case /* SALARY_PERIOD_DAILY */ 2 :
      return 2;
    case /* SALARY_PERIOD_WEEKLY */ 3 :
      return 3;
    case /* SALARY_PERIOD_BIWEEKLY */ 4 :
      return 4;
    case /* SALARY_PERIOD_MONTHLY */ 5 :
      return 5;
    case /* SALARY_PERIOD_ANNUAL */ 6 :
      return 6;
  }
}

function from_int_exn$1(n) {
  if (n > 6 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
      NAME: "Unknown_enum_value",
      VAL: n
    });
  } else {
    return n;
  }
}

function from_int$1(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return from_int_exn$1(e);
  });
}

function to_string$1(param) {
  switch (param) {
    case /* SALARY_PERIOD_UNSPECIFIED */ 0 :
      return "SALARY_PERIOD_UNSPECIFIED";
    case /* SALARY_PERIOD_HOURLY */ 1 :
      return "SALARY_PERIOD_HOURLY";
    case /* SALARY_PERIOD_DAILY */ 2 :
      return "SALARY_PERIOD_DAILY";
    case /* SALARY_PERIOD_WEEKLY */ 3 :
      return "SALARY_PERIOD_WEEKLY";
    case /* SALARY_PERIOD_BIWEEKLY */ 4 :
      return "SALARY_PERIOD_BIWEEKLY";
    case /* SALARY_PERIOD_MONTHLY */ 5 :
      return "SALARY_PERIOD_MONTHLY";
    case /* SALARY_PERIOD_ANNUAL */ 6 :
      return "SALARY_PERIOD_ANNUAL";
  }
}

function from_string_exn$1(s) {
  switch (s) {
    case "SALARY_PERIOD_ANNUAL" :
      return /* SALARY_PERIOD_ANNUAL */ 6;
    case "SALARY_PERIOD_BIWEEKLY" :
      return /* SALARY_PERIOD_BIWEEKLY */ 4;
    case "SALARY_PERIOD_DAILY" :
      return /* SALARY_PERIOD_DAILY */ 2;
    case "SALARY_PERIOD_HOURLY" :
      return /* SALARY_PERIOD_HOURLY */ 1;
    case "SALARY_PERIOD_MONTHLY" :
      return /* SALARY_PERIOD_MONTHLY */ 5;
    case "SALARY_PERIOD_UNSPECIFIED" :
      return /* SALARY_PERIOD_UNSPECIFIED */ 0;
    case "SALARY_PERIOD_WEEKLY" :
      return /* SALARY_PERIOD_WEEKLY */ 3;
    default:
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_name",
        VAL: s
      });
  }
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
}, SalaryPeriod, {
  name: name$1,
  to_int: to_int$1,
  from_int: from_int$1,
  from_int_exn: from_int_exn$1,
  to_string: to_string$1,
  from_string_exn: from_string_exn$1
});

function name$2(param) {
  return ".buhta.payroll.v1.SalaryMethod";
}

function to_int$2(param) {
  switch (param) {
    case /* SALARY_METHOD_UNSPECIFIED */ 0 :
      return 0;
    case /* SALARY_METHOD_GROSS */ 1 :
      return 1;
    case /* SALARY_METHOD_NET */ 2 :
      return 2;
  }
}

function from_int_exn$2(n) {
  if (n > 2 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
      NAME: "Unknown_enum_value",
      VAL: n
    });
  } else {
    return n;
  }
}

function from_int$2(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return from_int_exn$2(e);
  });
}

function to_string$2(param) {
  switch (param) {
    case /* SALARY_METHOD_UNSPECIFIED */ 0 :
      return "SALARY_METHOD_UNSPECIFIED";
    case /* SALARY_METHOD_GROSS */ 1 :
      return "SALARY_METHOD_GROSS";
    case /* SALARY_METHOD_NET */ 2 :
      return "SALARY_METHOD_NET";
  }
}

function from_string_exn$2(s) {
  switch (s) {
    case "SALARY_METHOD_GROSS" :
      return /* SALARY_METHOD_GROSS */ 1;
    case "SALARY_METHOD_NET" :
      return /* SALARY_METHOD_NET */ 2;
    case "SALARY_METHOD_UNSPECIFIED" :
      return /* SALARY_METHOD_UNSPECIFIED */ 0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_name",
        VAL: s
      });
  }
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
}, SalaryMethod, {
  name: name$2,
  to_int: to_int$2,
  from_int: from_int$2,
  from_int_exn: from_int_exn$2,
  to_string: to_string$2,
  from_string_exn: from_string_exn$2
});

function name$3(param) {
  return ".buhta.payroll.v1.SalaryRate";
}

function make(type$pOpt, periodOpt, method$pOpt, currency_codeOpt, rateOpt, param) {
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(SalaryType.from_int_exn, 0);
  const period = periodOpt !== undefined ? periodOpt : Curry._1(SalaryPeriod.from_int_exn, 0);
  const method$p = method$pOpt !== undefined ? method$pOpt : Curry._1(SalaryMethod.from_int_exn, 0);
  const currency_code = currency_codeOpt !== undefined ? currency_codeOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0);
  const rate = rateOpt !== undefined ? rateOpt : "";
  return {
    "type'": type$p,
    period: period,
    "method'": method$p,
    currency_code: currency_code,
    rate: rate
  };
}

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "type",
    "type"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(SalaryType),
  Curry._1(SalaryType.from_int_exn, 0)
]));

const merge_period = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "period",
    "period"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(SalaryPeriod),
  Curry._1(SalaryPeriod.from_int_exn, 0)
]));

const merge_method$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "method",
    "method"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(SalaryMethod),
  Curry._1(SalaryMethod.from_int_exn, 0)
]));

const merge_currency_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "currency_code",
    "currencyCode"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
  Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
]));

const merge_rate = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "rate",
    "rate"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge(t1, t2) {
  return {
    "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
    period: Curry._2(merge_period, t1.period, t2.period),
    "method'": Curry._2(merge_method$p, t1["method'"], t2["method'"]),
    currency_code: Curry._2(merge_currency_code, t1.currency_code, t2.currency_code),
    rate: Curry._2(merge_rate, t1.rate, t2.rate)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "type",
      "type"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(SalaryType),
    Curry._1(SalaryType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "period",
      "period"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(SalaryPeriod),
    Curry._1(SalaryPeriod.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "method",
      "method"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(SalaryMethod),
    Curry._1(SalaryMethod.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "currency_code",
      "currencyCode"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
    Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "rate",
      "rate"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._6(serialize, writer, param["type'"], param.period, param["method'"], param.currency_code, param.rate);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(type$p, period, method$p, currency_code, rate) {
  return {
    "type'": type$p,
    period: period,
    "method'": method$p,
    currency_code: currency_code,
    rate: rate
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1.SalaryRate", spec(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param["type'"], param.period, param["method'"], param.currency_code, param.rate);
  };
}

function constructor$1(type$p, period, method$p, currency_code, rate) {
  return {
    "type'": type$p,
    period: period,
    "method'": method$p,
    currency_code: currency_code,
    rate: rate
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1.SalaryRate", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, SalaryRate, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name$3,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "SalaryType"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "SalaryPeriod"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "SalaryMethod"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "SalaryRate"
    ]
  ]
}, V1, {
  SalaryType: SalaryType,
  SalaryPeriod: SalaryPeriod,
  SalaryMethod: SalaryMethod,
  SalaryRate: SalaryRate
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "SalaryType"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "SalaryPeriod"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "SalaryMethod"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "SalaryRate"
          ]
        ]
      },
      "V1"
    ]]
}, Payroll, {
  V1: V1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "SalaryType"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "SalaryPeriod"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "SalaryMethod"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "SalaryRate"
                ]
              ]
            },
            "V1"
          ]]
      },
      "Payroll"
    ]]
}, Buhta, {
  Payroll: Payroll
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
